import { render, staticRenderFns } from "./request-details-v2.modal.vue?vue&type=template&id=6cbb8bda&scoped=true"
import script from "./request-details-v2.modal.vue?vue&type=script&lang=js"
export * from "./request-details-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./request-details-v2.modal.vue?vue&type=style&index=0&id=6cbb8bda&prod&lang=scss&scoped=true"
import style1 from "./request-details-v2.modal.vue?vue&type=style&index=1&id=6cbb8bda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb8bda",
  null
  
)

export default component.exports